import React from "react";
import Link from "next/link";

const CreateAccountHelp = () => {
    return (
        <div className="space-y-4">
            <h2 className="text-xl font-semibold">Create an account</h2>
            <p>
                Create an account to save your favorites, request a tour, and ask the
                community a question.
            </p>
            <div className="grid gap-4">
                <div className="bg-gray-200 p-4 rounded-lg">
                    <h3 className="font-bold">Create an account</h3>
                    <p className="text-gray-8000 mt-1">
                        Click{" "}
                        <Link
                            href="/create-account"
                            className="text-primary-600 hover:text-primary-800 underline font-bold"
                        >
                            here
                        </Link>{" "}
                        to get started.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CreateAccountHelp;
